import { useEffect, useState } from "react";
import { useAgentServices } from "../models/agentServices";
import { OIDCService } from "../services/OIDCService";

export enum OIDCState {
  Pristine,
  Loading,
  Redirecting,
  Failed
}

export const useOIDCAuth = () => {
  const { oidcService } = useAgentServices();
  const [oidcLoadingState, setOidcLoadingState] = useState<OIDCState>(OIDCState.Loading);

  useEffect(() => {
    (async () => {
      const orgId = OIDCService.getUrlOrgIdParam();

      if (orgId) {
        try {
          await oidcService.redirectAuthorization(orgId);
          setOidcLoadingState(OIDCState.Redirecting);
        } catch (e) {
          setOidcLoadingState(OIDCState.Failed);
        }
      } else {
        setOidcLoadingState(OIDCState.Pristine);
      }
    })();
  }, []);

  return { oidcLoadingState };
};
